import { useCallback } from 'react';
import { ISignal, useCustomFetch } from "../custom-fetch";
import IUser from "../shared/IUser";


interface IGetUser extends ISignal {
  id: string;
}

interface IFetchUsers extends ISignal {
  organizationId?: string;
}

export const useUserService = () => {
  const customFetch = useCustomFetch();

  const fetchUsers = useCallback(async ({ signal, organizationId }: IFetchUsers) => {
    let url = "/json/users";
    if (organizationId) {
      url += `?organizationId=${organizationId}`;
    }
    const [users] = await customFetch<IUser[]>(url, { signal });
    return users;
  }, [customFetch]);
  
  const getUser = useCallback(async ({ signal, id }: IGetUser) => {
    const [user] = await customFetch<IUser>("/json/users?id=" + id, { signal });
    return user;
  }, [customFetch]);
  
  const saveUser = useCallback(async (data: IUser) => {
    const [user] = await customFetch<IUser>("/json/users/add", {
      method: "POST",
      body: JSON.stringify(data),
    });
    return user;
  }, [customFetch]);
  
  const updateUser = useCallback(async (id: string, data: IUser) => {
    const [user] = await customFetch<IUser>("/json/users/add", {
      method: "POST",
      body: JSON.stringify({ ...data, id }),
    });
    return user;
  }, [customFetch]);
  
  const deleteUser = useCallback(async (id: string) => {
    await customFetch<IUser>("/json/users/delete", {
      method: "POST",
      body: JSON.stringify({ ids: [id] }),
    });
    return true;
  }, [customFetch]);

  const registerFirebaseUser = useCallback(async (id: string) => {
    const [user] = await customFetch<IUser>("/json/users/firebase-register", {
      method: "POST",
      body: JSON.stringify({ id }),
    });
    return user;
  }, [customFetch]);
  
  return { fetchUsers, getUser, saveUser, updateUser, deleteUser, registerFirebaseUser };
}




